export const getFanclubPlansRoute = () => '/plans';
export const getFanclubPlanCreateRoute = () => '/plans/create';
export const getFanclubPlanEditRoute = (planId = null) => '/plans/' + (planId ?? ':plan');